export enum EAnalyticsScreenTabs {
  OVERVIEW = 'overview',
  VIEWS = 'views',
  ANSWERS = 'answers',
  COMMENTS = 'comments',
}
